import { Button, Col, Form, FormGroup } from "react-bootstrap";
import {
  ArrowClockwise,
  Bank2,
  CardChecklist,
  Filter,
  Map,
  Search,
} from "react-bootstrap-icons";

const FindCustomers = ({
  search,
  setSearch,
  setCity,
  setRegion,
  category,
  city,
  region,
  setCategories,
  handleGeneralSearch,
  handleNarrowSearch,
  handleResetGeneral,
  handleResetNarrow,
  validated,
  validatedNarrow,
  groupedData,
}) => {
  const grouped = groupedData && typeof groupedData === "object" && !Array.isArray(groupedData)
    ? groupedData
    : {};

  const regions = Object.keys(grouped);

  const getCitiesList = () => {
    const output = [];
    Object.values(grouped).forEach((arr) => {
      if (!Array.isArray(arr)) return;
      arr.forEach((x) => {
        if (x.state === region) {
          output.push(x.city);
        }
      });
    });
    return [...new Set(output)];
  };

  const getCategoriesList = () => {
    const output = [];
    Object.values(grouped).forEach((arr) => {
      if (!Array.isArray(arr)) return;
      arr.forEach((x) => {
        if (x.city === city && x.state === region) {
          output.push(x.category);
        }
      });
    });
    return [...new Set(output)];
  };

  return (
    <div className="search-hero-grid">
      {/* Search Panel — Thick Glass */}
      <div className="search-panel-glass">
        <h5 className="fw-bold mb-1 d-flex align-items-center gap-2" style={{ color: "var(--text-primary)" }}>
          <Filter style={{ color: "var(--accent)" }} /> Search vendor
        </h5>
        <p className="mb-3" style={{ fontSize: "13px", color: "var(--text-secondary)" }}>
          Filter by state, city, and business category
        </p>

        <Form className="d-flex flex-column gap-3">
          <FormGroup>
            <Form.Label
              htmlFor="state-region"
              className="fw-semibold d-flex align-items-center gap-2 mb-1"
              style={{ fontSize: "13px", color: "var(--text-primary)" }}
            >
              <Map style={{ color: "var(--accent-secondary)" }} /> State / Region
            </Form.Label>
            <Form.Select
              id="state-region"
              onChange={(e) => setRegion(e.target.value)}
              value={region}
              required
            >
              <option>Select</option>
              {regions?.map((element, index) => (
                <option key={index}>{element}</option>
              ))}
            </Form.Select>
          </FormGroup>

          <FormGroup>
            <Form.Label
              htmlFor="city"
              className="fw-semibold d-flex align-items-center gap-2 mb-1"
              style={{ fontSize: "13px", color: "var(--text-primary)" }}
            >
              <Bank2 style={{ color: "var(--accent-secondary)" }} /> City
            </Form.Label>
            <Form.Select
              id="city"
              onChange={(e) => setCity(e.target.value)}
              required
              value={city}
            >
              <option>Select</option>
              {getCitiesList()?.map((element, index) => (
                <option key={index}>{element}</option>
              ))}
            </Form.Select>
          </FormGroup>

          <FormGroup>
            <Form.Label
              htmlFor="category"
              className="fw-semibold d-flex align-items-center gap-2 mb-1"
              style={{ fontSize: "13px", color: "var(--text-primary)" }}
            >
              <CardChecklist style={{ color: "var(--accent-secondary)" }} /> Category
            </Form.Label>
            <Form.Select
              id="category"
              onChange={(e) => setCategories(e.target.value)}
              value={category}
              required
            >
              <option>Select</option>
              {getCategoriesList()?.map((element, index) => (
                <option key={index}>{element}</option>
              ))}
            </Form.Select>
          </FormGroup>

          <Col className="d-flex gap-2 mt-1">
            <Button
              size="sm"
              type="submit"
              className="btn-accent d-flex align-items-center gap-2"
              onClick={handleNarrowSearch}
              disabled={city === "" || region === "" || category === ""}
            >
              <Search /> Search
            </Button>
            <button
              type="button"
              className="btn-ghost d-flex align-items-center gap-2"
              style={{ fontSize: "13px", padding: "6px 14px" }}
              onClick={handleResetNarrow}
            >
              <ArrowClockwise /> Reset
            </button>
          </Col>
        </Form>
      </div>

      {/* Map Panel — Thick Glass */}
      <div className="map-panel-glass">
        <div className="map-header">
          <Map style={{ color: "var(--accent)" }} /> Southern Nigeria
        </div>
        <div className="map-body">
          <div className="map-embed">
            <iframe
              title="Southern Nigeria Map"
              src="https://www.openstreetmap.org/export/embed.html?bbox=2.5%2C4.2%2C10.0%2C8.5&layer=mapnik"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
          <div>
            <div className="mb-1" style={{ fontSize: "12px", fontWeight: 600, color: "var(--text-secondary)" }}>
              Key business regions
            </div>
            <div className="map-region-chips">
              {["Lagos", "Ogun", "Rivers", "Delta", "Edo", "Akwa Ibom", "Cross River", "Enugu", "Abia", "Imo"].map(
                (r) => (
                  <span key={r} className="map-region-chip">{r}</span>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindCustomers;
